<template>
  <v-card>
    <v-card-title class="d-flex">
      <div class="d-flex flex-column flex-grow-1">
        <div class="d-flex">
          <span class="mr-3">{{demo ? "Tägliche Übungen" : activity.name}}</span>
          <v-spacer></v-spacer>
          <v-btn class="mr-n3 mt-1" text small @click="plusMultiple" :disabled="saving">
            <v-icon class="grey--text text--darken-2">
              mdi-plus-box-multiple-outline
            </v-icon>
          </v-btn>
        </div>
        <span class="body-2 mt-1">{{bisJetzt}}/{{weekTarget}} {{unit}} {{freq}}</span>
      </div>
    </v-card-title>
    <v-card-text class="d-flex">
      <v-btn class="mt-1" :disabled="saving">
        <v-icon @click="change(-1)">
          mdi-minus
        </v-icon>
      </v-btn>
      <div class="mx-auto display-1">{{count}}</div>
      <v-btn class="accent mt-1" @click="change(+1)" :disabled="saving">
        <v-icon class="">
          mdi-plus
        </v-icon>
      </v-btn>
    </v-card-text>

    <v-dialog v-model="showDlg" width="400" :fullscreen="false">
      <v-card>
        <v-card-title>{{demo ? "Tägliche Übungen" : activity.name}}</v-card-title>
        <v-card-text>
          <v-text-field v-model="amount" :label="demo ? 'mal' : (activity.unit || 'mal')" ref="tf" inputmode="numbers"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mt-1" :disabled="saving || invalidAmount">
            <v-icon @click="change(-Math.abs(amount||0))">
              mdi-minus
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="" text @click="showDlg=false">
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="accent mt-1" @click="change(Math.abs(amount||0))" :disabled="saving || invalidAmount">
            <v-icon class="">
              mdi-plus
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-card>

</template>

<script>
import Activity from "@/components/Activity";
import Datum from "@/components/Datum";
import Kinds from "@/components/Kinds";
import ActivityLibrary from "@/components/ActivityLibrary";
import {formatDE} from "@/reusable/numbers";
import {Ziele} from "@/components/Ziele";
const {DateTime} = require("luxon");

export default {
  name: "Counter",
  props: ["activity", "targets", "activitySums", "demo"],
  data() {
    return {
      datetime:undefined,
      record: { value:0 },
      increment:0,
      saveDebounceTimer:undefined,
      saving:false,
      showDlg:false,
      amount:0,
    }
  },
  mounted() {
    this.datetime = DateTime.fromJSDate(new Date(Date.now())).setLocale("de");
    this.reload();
  },
  methods: {
    async reload() {
      if (this.demo) {
        this.increment=3;
        return;
      }
      this.loading = true;
      this.record= await this.load_record(this.activity.id, Date.now());
      console.log(this.record);
      this.loading = false;
    },
    async load_record(aid, date) {
      if (this.demo)
        return;
      if (!aid)
        return undefined;
      var id = Activity.makeRecordId(Datum.to_iso(date), aid);
      console.log("load_record: "+ id)
      var record = await this.$backend.get_object(Kinds.KIND_RECORD, id);
      return record;
    },
    async save_record(activity, date, value) {
      if (this.demo)
        return;
      var id = Activity.makeRecordId(Datum.to_iso(date), activity.id);
      var record = {id, activity: activity.id, date: Datum.to_iso(date), value};
      record=await this.$backend.set_object(Kinds.KIND_RECORD, id, record);
      this.$events.$emit("update_streak");
      return record;
    },
    async updateRecord(activity,diff){
      if (this.demo)
        return;
      var value=0;
      var record=await this.load_record(activity, Date.now());
      console.log({activity, record});
      var time = this.getDuration(activity, record);
      var new_time=time.plus(diff);
      if (activity.unit === "Stunden")
        value=new_time.as('hours');
      else
        value=new_time.as('minutes');
      this.save_record(activity, Datum.today(), value);
    },
    change(increment) {
      this.showDlg=false;
      this.increment+=increment;
      if (this.demo)
        return;
      if (this.saveDebounceTimer)
        clearTimeout(this.saveDebounceTimer);
      this.saveDebounceTimer=setTimeout(async ()=>{
        console.log(`Saving ${this.count}!`)
        this.saving=true;
        this.record=await this.load_record(this.activity.id, Date.now());
        var newCount=Math.max(0,this.count);
        this.record=await this.save_record(this.activity, Date.now(), newCount);
        this.increment=0;
        this.saving=false;
      }, 500);
    },
    plusMultiple() {
      this.amount="";
      this.showDlg=true;
      setTimeout(()=> this.$refs.tf.focus(), 100);
    },
  },
  computed: {
    isMobile() {
      return this.$app.mobile;
    },
    count() {
      if(this.demo)
        return this.increment;
      var r=this.record;
      if (!r)
        return this.increment;
      return this.increment + (r.value ?? 0);
    },
    bisJetzt() {
      if (this.demo)
        return 3;
      var sums=this.activitySums;
      if (!sums)
        return 0;
      var a= this.activity;
      if (!a)
        return 0;
      return formatDE(sums[this.activity.id] || 0);
    },
    unit() {
      var a= this.activity;
      if (!a)
        return "";
      if (a.type===ActivityLibrary.TYPE_BOOL)
        return "mal";
      return a.unit;
    },
    freq( ){
      if (this.demo)
        return "pro Woche";
      var a= this.activity;
      if (!a.freq || a.freq===ActivityLibrary.FREQ_DAILY || a.freq===ActivityLibrary.FREQ_WEEKLY)
        return "pro Woche"
      else
        return a.freq;
    },
    targetValues() {
      if (!this.targets)
        return undefined;
      var iso=Datum.today_iso();
      //console.log({iso});
      return new Ziele(this.targets).getTargets(iso);
    },
    weekTarget() {
      if (this.demo)
        return 7;
      var targets=this.targetValues;
      var actiTarget = this.activity.target;
      var aid=this.activity.id;
      //console.log(this.activity.name, targets ? targets[this.activity.id] : "null", "acti:", actiTarget);
      var t=((targets && targets.hasOwnProperty(aid)) ? targets[aid] || actiTarget : actiTarget) || 0;
      if (this.activity.type === ActivityLibrary.TYPE_BOOL && this.activity.freq === ActivityLibrary.FREQ_DAILY)
        return 7;
      else if (this.activity.freq === ActivityLibrary.FREQ_DAILY)
        return formatDE(t * 7);
      else
        return formatDE(t);
    },
    invalidAmount() {
      if (!this.amount)
        return true;
      var a = Math.abs(this.amount);
      //console.log({a});
      if (isNaN(a))
        return true;
      return false;
    }
  }
}
</script>

<style scoped>

</style>